export enum CalculatorTabType {
  ProfitLoss = 'ProfitLoss',
  TargetPrice = 'TargetPrice',
  LiquidationPrice = 'LiquidationPrice',
}

export enum TAB_TYPE {
  OPEN_POSITIONS,
  CLOSED_POSITIONS,
  ACTIVE_ORDERS,
  CONDITIONAL_ORDERS,
  FILLS,
  ORDER_HISTORY,
  TRADING_BOTS
}
